"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportRow = exports.ReportRowWrapper = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const Chevron = styled_components_1.default.div.withConfig({ displayName: "reports-Chevron", componentId: "reports-16d6jxz" }) `
  width: 12px;
  height: 12px;
  border-top: 2px solid ${base_react_components_1.theme.neutral400};
  border-left: 2px solid ${base_react_components_1.theme.neutral400};
  transform: rotate(135deg);
  margin-left: 8px;
  margin-top: 4px;
`;
const ReportRowWrapperValues = styled_components_1.default.div.withConfig({ displayName: "reports-ReportRowWrapperValues", componentId: "reports-16mzyji" }) `
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
const FlexHeader = styled_components_1.default.a.withConfig({ displayName: "reports-FlexHeader", componentId: "reports-grsfut" }) `
  underline: none,
  display: flex;
  justify-content: space-between;
`;
const InlineValue = styled_components_1.default.div.withConfig({ displayName: "reports-InlineValue", componentId: "reports-1yt5uia" }) `
  display: grid;
  grid-column-gap: 6px;
  align-items: flex-start;
`;
const Value = (0, styled_components_1.default)(base_react_components_1.Copy).attrs(() => ({ size: 'xs', bold: true })).withConfig({ displayName: "reports-Value", componentId: "reports-6wccj5" }) ``;
const Label = (0, styled_components_1.default)(base_react_components_1.Copy).attrs(() => ({ size: 'xs' })).withConfig({ displayName: "reports-Label", componentId: "reports-1252q63" }) `
  display: flex;
  flex-direction: column;
`;
const InlineValueLabel = (0, styled_components_1.default)(InlineValue).withConfig({ displayName: "reports-InlineValueLabel", componentId: "reports-512gdz" }) `
  grid-template-columns: minmax(10px, max-content) auto;
  grid-column-gap: 6px;
  grid-template-areas: 'value label';
  align-items: flex-start;

  & > ${Value} {
    grid-area: value;
  }

  & > ${Label} {
    grid-area: label;
  }

  @supports not (display: grid) {
    display: flex;
    & > :first-child {
      margin-right: 6px;
    }
  }
`;
const InlineValueLink = (0, styled_components_1.default)(InlineValue).withConfig({ displayName: "reports-InlineValueLink", componentId: "reports-7u9nez" }) `
  grid-template-columns: max-content max-content;
  grid-template-areas: 'value link';

  & > ${Value} {
    grid-area: value;
  }

  & > ${Chevron} {
    grid-area: link;
  }

  @supports not (display: grid) {
    display: flex;
    & > :last-child {
      margin-right: 6px;
    }
  }
`;
exports.ReportRowWrapper = (0, styled_components_1.default)(FlexHeader).attrs(() => ({ as: base_react_components_1.Link })).withConfig({ displayName: "reports-ReportRowWrapper", componentId: "reports-19dgs3w" }) `
  padding: 16px 0;
  border-top: 1px solid ${base_react_components_1.theme.neutral200};
  display: flex;
  flex-direction: column;
  background-color: ${base_react_components_1.theme.white};

  & > ${InlineValueLink} {
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 6px;
    margin-left: 16px;
  }

  /* Custom breakpoint is needed for tribureau display */
  @media (min-width: 880px) {
    flex-direction: row;
    justify-content: space-between;

    & > ${InlineValueLink} {
      margin: 0;
    }
  }
`;
const ReportRow = ({ amount, href, label, value }) => (react_1.default.createElement(exports.ReportRowWrapper, { href: href },
    react_1.default.createElement(ReportRowWrapperValues, null,
        react_1.default.createElement(InlineValueLabel, null,
            react_1.default.createElement(Value, null, value),
            react_1.default.createElement(Label, null, label)),
        !amount && react_1.default.createElement(Chevron, null)),
    !!href && (react_1.default.createElement(InlineValueLink, null, !!amount && (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(base_react_components_1.Copy, { bold: true, size: "xs" }, amount),
        react_1.default.createElement(Chevron, null)))))));
exports.ReportRow = ReportRow;
exports.default = exports.ReportRow;
//# sourceMappingURL=index.js.map